/**
 * Global Cart Notes Handler
 * Listens on the cart-drawer element (never replaced) so delegation works
 * when drawer content is refreshed after adding the first product.
 */
(function() {
  // Prevent double-loading if the theme reloads scripts
  if (window.CartNotesGlobalLoaded) return;
  window.CartNotesGlobalLoaded = true;

  function handleCartNotesClick(event) {
    // 1. Identify what was clicked (safely handling text nodes)
    const target = event.target instanceof Element ? event.target : event.target.parentNode;

    // --- HANDLE OPENING ---
    // Look for the toggle button
    const toggleBtn = target.closest('#order-note-toggle, .order-note-toggle');
    if (toggleBtn) {
      // Find the container relative to the button
      const container = toggleBtn.closest('cart-notes, .cart-notes');
      if (container) {
        const content = container.querySelector('.order-note-toggle__content');
        if (content) content.classList.add('active');
      }
      return;
    }

    // --- HANDLE CLOSING/SAVING ---
    // Look for the Close overlay OR the Save button
    const closeAction = target.closest('.order-note-toggle__content-overlay, .order-note-toggle__content .button');
    if (closeAction) {
      // Find the active container
      const container = closeAction.closest('cart-notes, .cart-notes');
      if (container) {
        const content = container.querySelector('.order-note-toggle__content');
        if (content) content.classList.remove('active');

        // If it was the SAVE button (not just the overlay), trigger the save
        if (closeAction.tagName === 'BUTTON' || closeAction.closest('button')) {
          saveCartNote(container);
        }
      }
    }
  }

  function initCartNotes() {
    var cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer && !cartDrawer._cartNotesBound) {
      cartDrawer._cartNotesBound = true;
      cartDrawer.addEventListener('click', handleCartNotesClick);
    } else if (!cartDrawer && !document._cartNotesDocBound) {
      document._cartNotesDocBound = true;
      document.addEventListener('click', handleCartNotesClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNotes);
  } else {
    initCartNotes();
  }

  // Helper function to save the note
  function saveCartNote(container) {
    const noteField = container.querySelector('textarea[name="note"]');
    if (!noteField) return;

    const routesUrl = (window.theme && window.theme.routes && window.theme.routes.cart_update_url)
                      ? window.theme.routes.cart_update_url
                      : '/cart/update';

    fetch(`${routesUrl}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ 'note': noteField.value })
    })
    .then(function() {})
    .catch(function(e) { console.error('CartNotes: Save failed', e); });
  }

})();
